import { schema } from "normalizr";

const hydraulikanlageSchema = new schema.Entity(
  "hydraulikanlage",
  {},
  { idAttribute: "id" }
);

export { hydraulikanlageSchema };
